import colors from './colors';

enum Breakpoint {
  xs = '375px',
  sm = '768px',
  md = '1024px',
  lg = '1280px',
  xl = '1440px',
}

export const breakpoints = [
  Breakpoint.xs,
  Breakpoint.sm,
  Breakpoint.md,
  Breakpoint.lg,
  Breakpoint.xl,
];

export const mediaQueries = {
  xs: `@media screen and (min-width: ${Breakpoint.xs})`,
  sm: `@media screen and (min-width: ${Breakpoint.sm})`,
  md: `@media screen and (min-width: ${Breakpoint.md})`,
  lg: `@media screen and (min-width: ${Breakpoint.lg})`,
  xl: `@media screen and (min-width: ${Breakpoint.xl})`,
};

export const space = {
  0: '0rem',
  0.2: '0.2rem',
  0.25: '0.25rem',
  0.5: '0.5rem',
  0.75: '0.75rem',
  1: '1rem',
  1.25: '1.25rem',
  1.5: '1.5rem',
  1.75: '1.75rem',
  2: '2rem',
  2.25: '2.25rem',
  2.5: '2.5rem',
  2.75: '2.75rem',
  3: '3rem',
  3.5: '3.5rem',
  3.75: '3.75rem',
  4: '4rem',
  4.25: '4.25rem',
  4.5: '4.5rem',
  5: '5rem',
  5.25: '5.25rem',
  5.5: '5.5rem',
  6: '6rem',
  8: '8rem',
  9: '9rem',
};

export const sizes = {
  carouselMobilePadding: '1.5rem',
  carouselDesktopPadding: '2.25rem',
  socialShareIcon: '1.774375rem',
  circledNumber: '3.3125rem',
  sideNavLogoHeightDesktop: '5.625rem',
  sideNavWidthDesktop: '12rem',
  sideNavAccountSectionHeightMobile: '5.3125rem',
  sideNavAccountSectionHeightDesktop: '5.5625rem',
  topBarHeightMobile: '3.6875rem',
  topBarHeightTablet: '5.25rem',
  footerMenuWidthDesktop: '13vw',
  notificationBarCloseIcon: '0.574375rem',
  articleContentPaddingMobile: '1.5rem',
  articleContentPaddingTablet: '2.25rem',
};

export const borders = {
  'gray-lighter': `1px solid ${colors['gray-lighter']}`,
  'blue-darker': `1px solid ${colors['blue-darker']}`,
  'black-opacity-20': `1px solid ${colors['black-opacity-20']}`,
};

const zIndices = {
  below: -1,
  '0': 0,
  '1': 1,
  '2': 2,
  '3': 3,
  '4': 4,
  'hero-button': 300,
  breadcrumbs: 600,
  'pop-up': 650,
  nav: 700,
  'progress-bar': 725,
  'notification-bar': 750,
  overlay: 800,
};

export const zIndex = (name: keyof typeof zIndices) => {
  return {
    zIndex: zIndices[name],
  };
};
